<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="1" y="1" width="12" height="12" stroke="#B5C6D8" stroke-width="2"/>
  <line x1="7" y1="3" x2="7" y2="11" stroke="#B5C6D8" stroke-width="2"/>
  <line x1="3" y1="7" x2="11" y2="7" stroke="#B5C6D8" stroke-width="2"/>
</svg>
</template>
